export class IngredientDetailDTO {
    ingredientId: number = 0
    price: number = 0
    quantity: number = 0
    unit: string = ''
    description: string = ''
    id!: number;
    status !: boolean
    option: string = ''
}